import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Breakdown} from 'src/app/model/quote/breakdown/breakdown.model';
import {BreakdownService} from '../breakdown.service';
import { coerceBreakdownIsMicroEnterprise, isFirstBreakdownMtaSave, resolveBreakdownOldPolicyId } from '../breakdown-policy-holder.util';
import {formatDate} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {QuoteService} from '../../quote.service';
import {environment} from '../../../../environments/environment';
import {LocalStorageService} from 'ngx-webstorage';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-breakdown-quotation',
  templateUrl: './breakdown-quotation.component.html',
  styleUrls: ['./breakdown-quotation.component.css', '../../quote.component.css']
})
export class BreakdownQuotationComponent implements OnInit, OnChanges, AfterViewChecked {
  public formFields: any;
  public submitted = false;
  public helptext = '';
  public parentModelObject: { [p: string]: any };
  public coverPeriod: string;
  public reference: any;
  public proposerType: string;
  public documents: any[] = [];
  public quoteScheduleDocUrl: string;
  public policyWordingDocUrl: string;
  public breakdownWordingDocUrl: string;
  public ipidWordingDocUrl: string;
  public ipidDoc: any = null;
  public policyWordingDoc: any = null;
  public quoteScheduleDoc: any = null;

  // isBroker = this.sessionSt.retrieve("is_broker");

  ipt = 0;
  gross = 0; // Principal Amount
  premiums: any = '{"referred": null,"ipt": 0,"gross": 0,"breakdown_ipt": 0,"breakdown_gross": 0,"total_amount": 0,"gross_premium":0,"vehicle_premiums": {},"breakdown_premiums": {},"vehicle_excesses": {},"driver_excesses": [ ],"compulsory_excess": 0}';
  hasErrors = false;
  // Peliwica fee is always zero for this product
  peliwica_fee = 0;

  UK_HB_INSURANCE_COMPANY_ID = '';
  isAdmin = false;
  isStaff = false;
  isBroker = false;

  @Input() authDetails: any;
  @Input() staticData: any;
  @Input() selectedIndex: number;
  @Input() modelObject: any;
  @Input() apiModelObject: any;
  @Input() originalPolicyId: string | null = null;

  @Output() modelObjectUpdated = new EventEmitter<Breakdown>();
  @Output() BackToVehicles = new EventEmitter<void>();

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private breakdownService: BreakdownService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private quoteService: QuoteService,
    private sessionSt: LocalStorageService,
    private _snackBar: MatSnackBar) {
  }

  get f(): { [key: string]: AbstractControl } {
    return this.formFields.controls;
  }

  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_staff')) {
      this.isStaff = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.isBroker = true;
    }

    this.UK_HB_INSURANCE_COMPANY_ID = environment.UK_HB_INSURANCE_COMPANY_ID;

    this.formFields = this.formBuilder.group({
      breakdown_cover: [''],
      registered_owner: [''],
      commission: ['20', Validators.required],
      broker_admin_fee: ['0', Validators.required],
      discount: ['0', Validators.required],
    });

    // TODO: Find where policy schedule and wording docs are stored/generated (for schedule)
    // commented until a non-brittle solution is found.

    // // This won't do the trick
    // const scheduleRegEx = new RegExp('/QT-\\d{6}_\\d{10}/');

    // this.quoteScheduleDocUrl = environment.apiURL + 'storage/app/public/quote/' + this.modelObject?.broker_id + '/' + this.modelObject?.id + '/' + this.modelObject?.quote_versions?.quote_ref_number + '.pdf';
    // console.log('quote schedule URL: ' + this.quoteScheduleDocUrl);
    // this.policyWordingDocUrl = 'https://s3-eu-west-1.amazonaws.com/amsamlin-uat/products/documents/horsebox%20wording%20may%202021.pdf';

    // breakdownWordingDocUrl = 'https://s3-eu-west-1.amazonaws.com/msamlin-uat/products/documents/horsebox%20breakdown%20wording%20november%202022.pdf';
    // this.breakdownWordingDocUrl = environment.apiURL + 'storage/static_documents/v1/amlin/Horsebox Breakdown Policy Document.pdf';

    // this.ipidWordingDocUrl = 'https://s3-eu-west-1.amazonaws.com/msamlin-uat/products/documents/horsebox%20ipid%20may%202021.pdf';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.selectedIndex === 2) {
      let inceptionDate: string | number | Date;
      if (this.modelObject.data) {
        this.parentModelObject = this.modelObject.data;
        inceptionDate = this.parentModelObject.attributes.application.policy_start_date;
        this.reference = this.modelObject.reference;
        this.proposerType = this.parentModelObject.attributes.application.policy_holder_detail.proposer_type;

      } else {
        this.parentModelObject = this.modelObject;
        inceptionDate = this.modelObject.inception_date;
        if (this.apiModelObject) {
          this.getDocuments(this.apiModelObject.id);
          // this.reference = this.apiModelObject.amlin_data.data.attributes.reference;
        } else {
          this.getDocuments(this.modelObject.id);
          // this.reference = this.modelObject.reference;
        }
        this.proposerType = this.modelObject.policy_holder_detail.proposer_type;
      }

      const maxDate = new Date(inceptionDate).setFullYear(new Date(inceptionDate).getFullYear() + 1);
      const newDate = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
      this.coverPeriod = formatDate(this.modelObject.policy_start_date, 'dd-MM-yyyy', 'en-US') + ' to ' + formatDate(this.modelObject.policy_end_date, 'dd-MM-yyyy', 'en-US');

      this.getPeliwicaPremium();

      this.formFields.get('broker_admin_fee').setValue(this.modelObject.brokerAdminFee);

    }
  }

  public ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  public patchValues() {
    this.formFields.patchValue({
      voluntary_excess: this.modelObject.voluntaryExcess,
      commission: 20, // this.modelObject.commission
      broker_admin_fee: this.modelObject.brokerAdminFee,
      discount: (this.modelObject.discount > 0) ? this.modelObject.discount : 0
    });

  }

  getPeliwicaPremium() {
    this.quoteService.getLiveStockBrokerCommission(this.modelObject.company_id, environment.BREAKDOWN_ID)
      .subscribe(
        (response: any) => {
          if (response.success) {
            if (this.modelObject.type == 3) {
              this.peliwica_fee = 0;
              this.formFields.get('peliwica_fee').setValue(0);
            } else {
              this.peliwica_fee = response.result.uw_fee;
              this.formFields.get('peliwica_fee').setValue(response.result.uw_fee);
            }
          }
        }
      );
  }

  /*
  * Save Quote Details
  */
  onSubmit() {
    this.submitted = true;

    if (!this.formFields.valid) {
      return false;
    }

    if (this.hasErrors) {
      return false;
    }

    if (this.modelObject.type === 2) {
      this.modelObject.policyId = null;
      this.modelObject.effectiveDate = null;
    }

    this.saveQuote();
  }

  saveQuote() {

    // If somehow we don't have a quote type at this stage, set it to 1 (new policy)
    if (this.modelObject.type === null || this.modelObject.type === undefined) {
      this.modelObject.type = 1;
    }

    const qType = Number(this.modelObject.type);
    const isMtaOrCancel = qType === 3 || qType === 4;
    const isFirstSave = isFirstBreakdownMtaSave(this.modelObject, this.apiModelObject, qType, this.originalPolicyId);
    const oldPolicyId = resolveBreakdownOldPolicyId(this.modelObject, this.apiModelObject, this.originalPolicyId);
    const quoteId = isFirstSave ? null : this.modelObject.id;

    const data = {
      "quote_data": {
        "id": quoteId,
        "company_id": this.modelObject.company_id,
        "policy_start_date": this.safeFormatDate(this.modelObject.inception_date || this.modelObject.policy_start_date),
        "policy_end_date": this.safeFormatDate(this.modelObject.policy_end_date || this.modelObject.cover_to),
        "broker_id": this.modelObject.broker_id,
        "type": this.modelObject.type,
        "policy_ref_number": this.modelObject.policyRefNumber || this.modelObject.policy_ref_number,
        "old_policy_id": oldPolicyId,
        "sequence_number": this.modelObject.sequenceNumber || this.modelObject.sequence_number,
        "quote_meta_id": this.modelObject.quote_meta_id,
        ...(qType === 3 ? { "effective_date": this.safeFormatDate(this.modelObject.effectiveDate || this.modelObject.effective_date) } : {}),
        "policy_holder": {
          "title": this.modelObject.policy_holder_detail.title,
          "first_name": this.modelObject.policy_holder_detail.first_name,
          "last_name": this.modelObject.policy_holder_detail.last_name,
          "email": this.modelObject.policy_holder_detail.email,
          "phone": this.modelObject.policy_holder_detail.phone,
          "mobile": this.modelObject.policy_holder_detail.mobile ? this.modelObject.policy_holder_detail.mobile : '',
          "dob": this.modelObject.policy_holder_detail.dob,
          "company_name": this.modelObject.policy_holder_detail.company_name ? this.modelObject.policy_holder_detail.company_name : '',
          "trading_name": this.modelObject.policy_holder_detail.trading_name ? this.modelObject.policy_holder_detail.trading_name : '',
          "proposer_type": this.modelObject.policy_holder_detail.proposer_type,
          "is_micro_enterprise": coerceBreakdownIsMicroEnterprise(this.modelObject.policy_holder_detail),
          "address": {
            "address1": this.modelObject.policy_holder_detail.address.address1,
            "address2": this.modelObject.policy_holder_detail.address.address2,
            "address3": this.modelObject.policy_holder_detail.address.address3,
            "address4": this.modelObject.policy_holder_detail.address.address4,
            "city": this.modelObject.policy_holder_detail.address.city,
            "country": "UK",
            "postcode": this.modelObject.policy_holder_detail.address.postcode,
          },
          "sms": this.modelObject.policy_holder_detail.sms,
          "post": this.modelObject.policy_holder_detail.post,
          "is_phone": this.modelObject.policy_holder_detail.is_phone,
          "is_email": this.modelObject.policy_holder_detail.is_email,
        },
        "vehicle_details": this.modelObject.vehicles,
      }
    };

    this.breakdownService.saveQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            const savedQuote = res.result?.quote;
            if (savedQuote) {
              this.modelObject = savedQuote;
            }
            this._snackBar.open('Quote Saved.', '', {
              duration: 5000,
              panelClass: 'text-success'
            });
            this.modelObjectUpdated.emit(this.modelObject);
            const quoteId = savedQuote?.id || this.modelObject.id;
            this.router.navigateByUrl('/breakdown/quote-details/' + quoteId);
          } else {
            this._snackBar.open(res.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }

          this.modalService.dismissAll();
        });
  }

  public getDocuments(id) {
    const isMTA = this.apiModelObject && Number(this.apiModelObject.type) === 3;
    const docType = isMTA ? 3 : 1; // 1 = quote, 3 = MTA
    const isUnderwritten = this.apiModelObject && this.apiModelObject.is_underwritten != null
      ? Number(this.apiModelObject.is_underwritten) : 0;

    this.breakdownService.getQuoteDocuments(id, docType, isUnderwritten)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.documents = response.result || [];
            const generatedDocs = this.documents.filter(doc => doc.is_static == 0);
            const staticDocs = this.documents.filter(doc => doc.is_static == 1);
            const uniqueDocuments = this.getLatestUniqueDocuments(generatedDocs);
            const baseUrl = environment.apiURL.replace('/api/', '');
            // Schedule: for MTA look for title containing 'Schedule' (e.g. MTA Quotation Schedule), else New Business
            const scheduleDoc = uniqueDocuments.find(doc => doc.title && doc.title.includes('Schedule'))
              
            this.quoteScheduleDocUrl = scheduleDoc ? baseUrl + scheduleDoc.download_path : '';
            
            this.ipidDoc = staticDocs.find(doc => doc.title === 'Breakdown IPID') || null;
            this.ipidWordingDocUrl = this.ipidDoc ? baseUrl + this.ipidDoc.download_path : '';

            this.policyWordingDoc = staticDocs.find(doc => doc.title === 'BREAKDOWN POLICY WORDING') || null;
            this.policyWordingDocUrl = this.policyWordingDoc ? baseUrl + this.policyWordingDoc.download_path : '';

            this.quoteScheduleDoc = scheduleDoc || null;
          }
        }
      );
  }

  public getLatestUniqueDocuments(documents: any[]): any[] {
    // Group documents by a unique identifier (adjust based on your data structure)
    // Assuming documents have an 'id' or 'title' field to identify duplicates
    const documentMap = new Map<string, any>();

    documents.forEach(doc => {
      const key = doc.title || doc.id; // Use title or id as the unique key
      const existing = documentMap.get(key);

      // Keep the document with the latest date/timestamp
      // Adjust the date field name based on your data structure (e.g., 'created_at', 'updated_at', 'timestamp')
      if (!existing || new Date(doc.created_at) > new Date(existing.created_at)) {
        documentMap.set(key, doc);
      }
    });

    return Array.from(documentMap.values());
  }
  downloadDocument(actionType: string, document: any) {
    if (actionType === 'download') {
      this.quoteService.downloadDocs(document);
    }
  }
  getDisplayTitle(title: string): string {
    if (!title) {
      return '';
    }

    const t = title.toUpperCase();

    if (t.includes('QUOTE')) {
      return 'Quote Schedule';
    }

    if (t.includes('POLICY')) {
      return 'Policy Wording';
    }

    if (t.includes('IPID')) {
      return 'IPID';
    }

    return title; // fallback
  }

  private safeFormatDate(value: any): string {
    if (!value) return '';
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    return formatDate(new Date(value), 'yyyy-MM-dd', 'en-US');
  }
}
